export default "__VITE_ASSET__CIIxHb8E__"